import React from 'react';

import {getCookie, setCookie} from '../Common.js';


class Pagination extends React.Component{

    _pagesListRef = React.createRef();


    state = {
        pagesOpen: false
    }
    

    componentDidMount(){
        const cookieData = localStorage.getItem('pagination_pages_open');

            if(cookieData){
                this.setState({
                    pagesOpen: JSON.parse(cookieData.toLowerCase())
                })
            }
    }


    componentDidUpdate(prevProps, prevState){

            if(!this.props.loading) this.updateClasses();
    }


    updateClasses =()=>{
        
       const baseEls = document.querySelectorAll('.esd-pagination');

        baseEls.forEach(function(bel) {
            const els = bel.querySelectorAll('.btn');

                els.forEach(function(el) {
                    el.classList.remove('btn-loading');
                });
        });
    }


    onPageSelect =(evt)=> {

        evt.currentTarget.classList.add('btn-loading');
        let p = evt.currentTarget.value;

            if(p <= 1) p = 1;

        this.props.onPageSelect(p);
    }


    makePagesList = () => {

            if(this.props.totalPages <= 1) return [];

        let renderedList = [];

            for (var i = 1; i <= this.props.totalPages; i++) {

                let listItemsClass = 'esd-list-item';

                    if(parseInt(this.props.page) === i) listItemsClass += ' esd-list-item-selected';

                    if( (i <= 8 && this.props.page < 4) || (i >= this.props.totalPages-8 && this.props.page > this.props.totalPages-8) ||  (i === 1 || i === this.props.totalPages) || (i >= this.props.page-4 && i < this.props.page+4) ){

                        renderedList.push(<li key={i} className={listItemsClass}><button className="btn btn-3rd esd-pagination-item"
                        value={i}
                        onClick={this.onPageSelect}
                        aria-label={"Page " + i}
                        >{i}</button></li>)
                    }
            }

        return renderedList;
    }


    togglePages =(evt)=>{
        
        let open = this.state.pagesOpen;

            if(open) open = false;
            else open = true;

            if(this._pagesListRef.current.clientHeight > 0) open = false;

        this.setState({
            pagesOpen: open
        });
    
        localStorage.setItem('pagination_pages_open', open);
        open = null;        
    }


    render(){

            if(this.props.totalPages <= 1) return '';

        let prevLinksClss = "btn btn-3rd esd-pagination-item float-left", disabled = false;
        let nextLinksClss = "btn btn-3rd esd-pagination-item float-right", disabled_next = false;

            if(this.props.page-1 < 1) {
                prevLinksClss += ' btn-disabled';
                disabled = true;
            }

            if(this.props.page+1 > this.props.totalPages) {
                nextLinksClss += ' btn-disabled';
                disabled_next = true;
            }


        const pageToggleBtn = <button
                                type="button"
                                onClick={this.togglePages}
                                className="btn btn-primary d-none d-md-block"
                                ><i className="fas fa-book-open"></i>{this.props.page}/{this.props.totalPages}{(this.state.pagesOpen ? <i className="fa fa-chevron-up" aria-hidden="true"></i> : <i className="fa fa-chevron-down" aria-hidden="true"></i>)}
                                </button>

        return (
            <div className="row no-gutters esd-pagination">
                <div className={"esd-pagination-controls" + (this.props.totalPages < 8 ? ' d-none' : '')}>
                    <ul className="col-12">
                        <li>
                            <button
                            className={prevLinksClss + ' btn-icon btn-icon-fast-backward'}
                            value="1"
                            onClick={this.onPageSelect}
                            aria-label="Start"
                            disabled={disabled}
                            ></button>
                        </li>
                        <li>
                            <button
                            className={prevLinksClss + ' btn-icon btn-icon-previous float-left'}
                            value={this.props.page-1}
                            onClick={this.onPageSelect}
                            aria-label="Previous page"
                            disabled={disabled}
                            ></button>
                        </li>
                        <li className="d-none d-md-block">
                            {pageToggleBtn}
                        </li>
                        <li>
                            <button
                            className={nextLinksClss + ' btn-link'}
                            value={this.props.page+1}
                            onClick={this.onPageSelect}
                            aria-label="Next page"
                            disabled={disabled_next}
                            ></button>
                        </li>
                        <li>
                            <button
                            className={nextLinksClss + ' btn-icon btn-icon-fast-forward '}
                            aria-label="Button disabled"
                            value={this.props.totalPages}
                            onClick={this.onPageSelect}
                            disabled={disabled_next}
                            ></button>
                        </li>
                    </ul>
                    <ul className="col-md-12 d-md-none">
                        <li>
                        {pageToggleBtn}
                        </li>
                    </ul>
                </div>
                <div id={this.props.selector} ref={this._pagesListRef} className={"esd-pagination-pages-list col-12 text-center " + (this.state.pagesOpen || this.props.totalPages < 8 ? 'd-block' : 'd-md-none')}>
                    <ul className={'d-flex' + (this.props.totalPages < 8 ? ' justify-content-center' : '')}>
                        {this.makePagesList()}
                    </ul>
                </div>

            </div>
        )
    }
}


export default Pagination;